import "./Comment.scss"
import {useEffect, useRef} from "react";
import {useParams} from "react-router-dom";
import {useNotification} from "../../hooks/useNotification";
import Avatar from "../Avatar/Avatar";
import CommentActions from "../../api/CommentActions";
import {useFormik} from "formik";
import * as Yup from "yup";
import Input from "../Input/Input";
import Button from "../Button/Button";

const validationSchema = Yup.object({description: Yup.string().trim().required('Description is required')});

const CommentModal = ({user, comment, checkpointId, onSave, onClose, commentButtonPos, posY}) => {
    const {id} = useParams();
    const commentRef = useRef(null);
    const {triggerNotification} = useNotification();

    const formik = useFormik({
        initialValues: {
            id: comment?.id,
            description: comment?.description || ""
        },
        validationSchema: validationSchema,
        onSubmit: (values) =>{
            const data = values.id ? {id: comment.id, description: values.description} : {description: values.description, document: {id}, checkpoint: {id: checkpointId}};

            CommentActions.save(data, res => {
                onSave(res);
                triggerNotification(values.id ? "Comment updated successfully" : "Comment saved successfully");
            })
        }
    })


    const handleClickOutside = (e) => {
        if (commentRef.current && !commentRef.current.contains(e.target)) {
            onClose();
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return(
        <div ref={commentRef} className="comment comment-modal" style={{top: posY ?? commentButtonPos?.y ?? 0}}>
            <div className="user-info">
                <Avatar name={user?.name} surname={user?.surname} color={user?.color} url={user?.image}/>
                <div className="info">
                    <div className="username">{user?.name} {user?.surname}</div>
                </div>
            </div>

            <div className="comment-form">
                <Input
                    name="description"
                    type="text"
                    layout="vertical"
                    required={false}
                    formik={formik}
                />
            </div>
            <div className="actions">
                <Button onClick={formik.handleSubmit}>
                    {formik.values.id ? "Update" : "Comment"}
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </div>
        </div>
    )
}

export default CommentModal
